import React from "react";
import Moods from "../components/MoodComponents/Moods.jsx";
import { useState, useEffect, useContext, useMemo } from "react";
import { useHistory } from "react-router-dom";
import { destroyMood, getAllMoods, postMood, putMood, filterByDate } from '@care/shared';
import { CurrentUserContext } from "../context/CurrentUserContext";
import { DateContext } from "../context/DateContext";

export default function MoodsContainer({ onFilteredCount, createOpen, onCloseCreate, optionsOpen }) {
  const [currentUser] = useContext(CurrentUserContext);
  const { selectedDate } = useContext(DateContext);
  const [moods, setMoods] = useState([]);
  const [updated, setUpdated] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const history = useHistory();

  useEffect(() => {
    const fetchMoods = async () => {
      const moodData = await getAllMoods();
      setMoods(moodData);
      setLoaded(true);
    };
    fetchMoods();
  }, [currentUser]);

  const handleCreate = async (moodData) => {
    const newMood = await postMood(moodData);
    setMoods((prevState) => [...prevState, newMood]);
  };

  const handleUpdate = async (id, moodData) => {
    const updatedMood = await putMood(id, moodData);
    setMoods((prevState) =>
      prevState.map((mood) => {
        return mood.id === Number(id) ? updatedMood : mood;
      })
    );
    setUpdated(true);
    history.push("/");
  };

  const handleDelete = async (id) => {
    await destroyMood(id);
    setMoods((prevState) => prevState.filter((mood) => mood.id !== id));
  };

  const filteredMoods = useMemo(
    () => filterByDate(moods, selectedDate, "time"),
    [moods, selectedDate]
  );

  useEffect(() => {
    onFilteredCount?.(filteredMoods.length);
  }, [filteredMoods.length, onFilteredCount]);

  return (
    <>
      <Moods
        moods={filteredMoods}
        setMoods={setMoods}
        updated={updated}
        loaded={loaded}
        handleCreate={handleCreate}
        handleDelete={handleDelete}
        handleUpdate={handleUpdate}
        createOpen={createOpen}
        onCloseCreate={onCloseCreate}
        optionsOpen={optionsOpen}
      />
    </>
  );
}
